// src/services/authService.js
import { apiClient, adminApiClient, setAuthToken, stopAutoRenewAll } from "./apiClient";

/**
 * Login with interceptors disabled for this call.
 */

export async function login(
  username = process.env.REACT_APP_USERNAME,
  password = process.env.REACT_APP_PASSWORD,
  tenantId = process.env.REACT_APP_TENANT_ID,
  // username = 'communityadmin@gmail.com',
  // password = 'adminpass1!',
  // tenantId = 4,
  useAdminApi = false
) {
  const client = useAdminApi ? adminApiClient : apiClient;

  try {
    
    const payload = { Username: username, Password: password, Tenant_Id: tenantId || "" };
    const response = await client.post("/Auth/LoginMultiTenantWithTenantId", payload, { _skipAuth: true });
    const token = response?.data?.token;

    if (token) {
      const key = useAdminApi ? "adminAuthToken" : "apiAuthToken";
      localStorage.setItem(key, token);
      setAuthToken(token, useAdminApi);
    }

    return response.data;
  } catch (error) {
    console.error("Login failed:", error?.response?.data || error?.message);
    throw error;
  }
}

export function logout() {
  localStorage.removeItem("apiAuthToken");
  localStorage.removeItem("adminAuthToken");
  setAuthToken(null, false);
  setAuthToken(null, true);
  stopAutoRenewAll(); // ⛔ stop timers
}
